import { css, SerializedStyles } from '@emotion/react';
import { theme } from '@frontend/theme';
import { useHasScroll } from '../../hooks/useHasScroll/useHasScroll';
import { CONTAINER_WIDTH, FOOTER_HEIGHT_CSS_VAR, HEADER_HEIGHT_CSS_VAR } from './constants';

const containerStyles = css`
  background-color: ${theme.colors.neutral5};
  padding-top: var(${HEADER_HEIGHT_CSS_VAR}, 0);
  padding-bottom: var(${FOOTER_HEIGHT_CSS_VAR}, 0);
  min-height: 100dvh;
`;

const contentStyles = css`
  max-width: ${CONTAINER_WIDTH}px;
  margin: 0 auto;
  padding: ${theme.spacing(1)};
`;

interface ContentContainerProps extends React.PropsWithChildren {
  contentCss?: SerializedStyles;
}

const ContentContainer = ({ children, contentCss }: ContentContainerProps) => {
  const { elRef, ScrollCue, scrollCueProps } = useHasScroll<HTMLDivElement>({ useWindowScroll: true });

  return (
    <>
      <main css={containerStyles}>
        <div ref={elRef} css={[contentStyles, contentCss]}>
          {children}
        </div>
      </main>
      <ScrollCue {...scrollCueProps} />
    </>
  );
};

export default ContentContainer;
